import * as React from 'react';
import { RouteName, RoutePath, ScreenName } from '@helpcenter/constants';
import type { PaperAppearance } from 'view/layout/paper';
import { createRouteWithLayout } from '@atlassian/help-center-common-util/resource-router';

// Temporary placeholder component until @atlassian/csm-folder is implemented
const CsmFolder = () => <></>;

const folder = {
    resources: [],
    name: RouteName.CSM_FOLDER_PAGE,
    path: RoutePath.CSM_FOLDER_PATH,
    exact: true,
    component: CsmFolder,
};

const layoutProps = {
    isAnonymous: false,
    paperAppearance: 'wide' as PaperAppearance,
    fadeInSearchModal: true,
    prefetchBrandingModel: true,
};

export const csmFolderRoute = createRouteWithLayout(folder, ScreenName.CSM_FOLDER, layoutProps);
